module.exports = __webpack_public_path__ + "img/logo.5a106fd2.png";